<template>
    <div class="theme-pill">
        <div class="title text-truncate">
            {{ theme.title }}
        </div>
        <a href="#">
            <slot name="icon">
                <img src="@assets/img/right-arrow-bi.svg" width="20px">
            </slot>
        </a>
        <div :style="{ width: theme.progress+'%' }" class="reading-progress" />
    </div>
</template>

<script>
export default {
    name: "ThemePill",
    props:{
        theme: {
            type: Object,
            default() {
                return {
                    title:"default",
                    seek: 0 }
            }
        }
    },
    computed:{
        styleWith() {
            return {
                width: `${this.theme.progress}%`
            }
        }
    }
}
</script>

<style lang="scss">
.theme-pill {
    height: 40px;
    border-radius: 6px;
    border: 1px solid #636363;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: $medium-gray;
    padding: 0 15px;
    position: relative;
    cursor: pointer;
    overflow: hidden;

    .title {
        color: white;
        font-size: 13px;
        font-weight: 600;
        line-height: 18px;
        z-index: 1;
    }

    a {
        display: flex;
        align-items: center;
        z-index: 1;
        margin-left: 10px;
    }

    .reading-progress {
        background-color: $primary-color;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        transition: width .3s ease-in;
    }
}
</style>

